import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * PDF of an application page (the confirmation email after submit, and "Download Full Application"):
 * a capture of the element sliced into A4 pages. Captured at 1x as JPEG (80%) instead of a full-size
 * PNG: several times faster and the file is a fraction of the size, which mail servers accept.
 */
export async function captureElementToPdf(element: HTMLElement, fileName: string): Promise<File> {
  const canvas = await html2canvas(element, {
    scale: 1,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
  });

  const pdf = new jsPDF('p', 'mm', 'a4', true);
  const imgWidth = 208;
  const pageHeight = 295;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  const pageCount = Math.max(1, Math.ceil(imgHeight / pageHeight));
  const image = canvas.toDataURL('image/jpeg', 0.8);

  for (let page = 0; page < pageCount; page++) {
    if (page > 0) {
      pdf.addPage();
    }
    // the same image moved up one page height for each page
    pdf.addImage(image, 'JPEG', 0, -page * pageHeight, imgWidth, imgHeight, undefined, 'FAST');
  }

  return new File([pdf.output('blob')], fileName, { type: 'application/pdf' });
}
